import { axiosInstance } from '../request';
export const getAvatar = async () => {
    const response = await axiosInstance.get('/api/v1/avatar');
    return response.data;
};
export const getAvatarImage = async (id, updatedAt) => {
    const response = await axiosInstance.get(`/api/v1/avatar/image/${id}`, {
        responseType: 'blob',
        params: { t: updatedAt }
    });
    return URL.createObjectURL(response.data);
};
export const uploadAvatar = async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await axiosInstance.put('/api/v1/avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};
export const resetAvatar = async () => {
    await axiosInstance.post('/api/v1/avatar/reset');
};
//# sourceMappingURL=avatar.api.js.map